module.exports = __webpack_public_path__ + "img/DW365-105.19e25635.jpg";